import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, LOCALE_ID } from '@angular/core';
import { customFieldsBase } from '../custom-fields-base';

@Component({
    selector: 'app-custom-fields-radio-type',
    templateUrl: './custom-fields-radio-type.component.html',
    styleUrls: ['./custom-fields-radio-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldsRadioTypeComponent extends customFieldsBase {
    constructor(cdr: ChangeDetectorRef, @Inject(LOCALE_ID) localeId: string) {
        super(cdr, localeId);
    }
}
